
import {UIGameEventDiceView} from '../../../../../shared/scripts/ui_game/ui_game_cities_and_knights/ui_game_cities_and_knights_dice/UIGameEventDiceView'
import {UIGameEventDiceController} from '../../../../../shared/scripts/ui_game/ui_game_cities_and_knights/ui_game_cities_and_knights_dice/UIGameEventDiceController'
import {UIGameDiceView} from '../../../../../shared/scripts/ui_game/ui_game_dice/UIGameDiceView'
import {GameStateEnums} from '../../../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {bringToFront} from '../../../../../shared/scripts/ui_utils/PixiUtils'
import {UIUtilsEjsVariables} from '../../../../../shared/scripts/UIUtilsEjsVariables'
import {UIMGameManager} from '../../UIMGameManager'
import {MechanicEventDiceState} from '@colonist/game-states'
import {UIMGameAnimationController} from '../../ui_game_animation/UIMGameAnimationController'

export class UIMGameEventDiceController extends UIGameEventDiceController {
    private readonly animationController: UIMGameAnimationController

    constructor(uiGameManager: UIMGameManager, eventDiceState: MechanicEventDiceState) {
        super(uiGameManager, eventDiceState)

        this.animationController = uiGameManager.animationController
        this.animationController.registerForFeedMechanics(this.playerDiceView)
    }

    onEvent(data: any, eventType: GameStateEnums.UIGameEventEnums) {
        super.onEvent(data, eventType)
        switch(eventType) {
            case UIGameEventEnums.ShowTradeUI: this.setMyDiceViewVisibility(false); break
            case UIGameEventEnums.CloseTradeUI: this.setMyDiceViewVisibility(true); break
            case UIGameEventEnums.GameEndHideMap: this.setMyDiceViewVisibility(false); break
            case UIGameEventEnums.GameEndShowMap: this.setMyDiceViewVisibility(true); break
            case UIGameEventEnums.PopupActive: this.setMyDiceViewVisibility(data == undefined); break
            case UIGameEventEnums.ReplayModeStart: this.setDicePositionForReplay(); break
            default: break
        }
    }

    private setDicePositionForReplay() {
        const canvas = this.uiGameManager.canvasController
        const eventDiceSize = canvas.itemSize * 2 / 3
        const y = canvas.appH - canvas.bottomViewHeight - this.uiGameManager.gameLayout.getReplayViewHeight() - eventDiceSize
        this.playerDiceView.y = y
        this.playerDiceView.initialPosition.y = y
    }

    protected initializePlayerDiceView() {
        const canvas = this.uiGameManager.canvasController
        const padding = canvas.itemSize / 8
        const actionButtonSize = canvas.itemSize
        const diceSize = canvas.itemSize
        const eventDiceSize = canvas.itemSize * 2 / 3

        const x = canvas.appW - diceSize * 2 - eventDiceSize - padding * 3
        const yDefault = this.uiGameManager.actionsController.container.y - eventDiceSize - padding * 2
        const yReplay = canvas.appH - canvas.bottomViewHeight - this.uiGameManager.gameLayout.getReplayViewHeight() - eventDiceSize
        const y = this.uiGameManager.gameController.isReplay ? yReplay : yDefault

        this.playerDiceView = new UIGameEventDiceView(this.uiGameManager, this.eventDiceState, x, y, eventDiceSize, this.uiGameManager.canvasController.app.stage, (dice) => this.clickedDice(dice))
        this.playerDiceView.resetDice()
        this.playerDiceView.hide()
    }

    protected initializeOpponentDiceViews() {
        this.opponentDiceViews = []
        const playersController = this.uiGameManager.playersController
        const playerViewWidth = playersController.playerInformationViews[0].width
        const playerViewHeight = playersController.playerInformationViews[0].height

        const opponentDiceSize = playerViewHeight / 3
        const margin = opponentDiceSize * 0.125
        const baseDiceY = -opponentDiceSize * 0.5 - margin
        let index = 1

        for(const playerView of playersController.playerInformationViews) {
            if(playerView.player.color == this.uiGameManager.gameController.myColor) continue
            const isPlayerOnLeft = UIUtilsEjsVariables.isUserOnTabletApp ? false : (playerView.position.x < this.uiGameManager.canvasController.appW / 2)
            const baseDiceX = isPlayerOnLeft ? playerViewWidth + margin * 1.25 : -opponentDiceSize - margin * 1.25

            const opponentDice = new UIGameEventDiceView(this.uiGameManager, this.eventDiceState, baseDiceX, baseDiceY, opponentDiceSize, playerView, (dice) => this.clickedDice(dice), false)
            opponentDice.tintPassive()
            opponentDice.hide()
            this.opponentDiceViews.push(opponentDice)
            index += 1
        }
    }

    protected getOpponentDiceViewToDisplay(currentTurnPlayerIndex: number, opponentCount: number): UIGameDiceView {
        return this.opponentDiceViews[currentTurnPlayerIndex]
    }

    protected redrawDiceViews() {
        this.animationController.unregisterForFeedMechanics(this.playerDiceView)
        super.redrawDiceViews()
        this.animationController.registerForFeedMechanics(this.playerDiceView)
    }

    protected updateDiceView() {
        super.updateDiceView()
        bringToFront(this.uiGameManager.actionsController.container)
        if(this.playerDiceView.parent == undefined) return

        this.playerDiceView.onCompleteCallback(() => {
            const canvas = this.uiGameManager.canvasController
            const padding = canvas.itemSize / 8
            const eventDiceSize = canvas.itemSize * 2 / 3

            const replayViewHeight = this.uiGameManager.gameLayout.getReplayViewHeight()
            const y = this.uiGameManager.gameController.isReplay
                ? canvas.appH - canvas.bottomViewHeight - replayViewHeight - this.playerDiceView.height
                : this.uiGameManager.actionsController.container.y - eventDiceSize - padding * 2
            this.playerDiceView.y = y
        })
    }
}
